export default __webpack_public_path__ + "static/media/audio.a93165d9.svg";